import api from './api';

export const getSourceData = async () => {
  const { data } = await api.get('/v1/users/source_data');
  return data;
};
